
import { useRef } from "react";
import MeaContractTotalAmount from "../../../registrations/components/MeaContractTotalAmount";
import MeaButton from "../../../../components/MeaButton";
import MeaLink from "../../../../components/MeaLink";
import UpdateContractTotalAmountModal from "../modals/UpdateContractTotalAmountModal";
import SubscriptionTableModal from "../modals/SubscriptionTableModal";
import { PERMISSION_TRAINING_CONTRACTS } from "../../../../permissions";
import MeaContractDueBalance from "../../../registrations/components/MeaContractDueBalance";
const ContractDetailHeader = ({ contract, callback, schoolId, trainingId }) => {

    const updateContractTotalAmountModalRef = useRef(null);
    const subscriptionTableModalRef = useRef(null);

    return (
        <>
            <UpdateContractTotalAmountModal ref={updateContractTotalAmountModalRef} contract={contract} schoolId={schoolId} trainingId={trainingId} />
            <SubscriptionTableModal ref={subscriptionTableModalRef} />
            <div>
                <div className="surface-section px-4 py-5 md:px-6 lg:px-5 flex flex-wrap">
                    <div className="w-full md:w-6">
                        <div className="flex align-items-center ">
                            <span className="text-2xl font-bold">{contract?.name}</span>
                        </div>
                        <div className="flex align-items-center text-600 mt-3">
                            <span className="mr-5">
                                <i className="pi pi-chevron-circle-right mr-2"></i>Contrat de formation:
                            </span>
                        </div>
                        <div className="flex align-items-center mt-2 ml-4">
                            <MeaLink to={`/school/${schoolId}/admin/trainings/${trainingId}/`} >
                                {contract?.training?.name}
                            </MeaLink>
                        </div>
                    </div>
                    <div className="w-full md:w-6 flex flex-column md:flex-row md:align-items-center md:justify-content-end mt-4 md:mt-0">
                        <div className="flex align-items-center mr-0 md:mr-5">
                            <div className="flex gap-2">
                                <MeaButton 
                                    outlined 
                                    tooltip="Tableau des cotisations" 
                                    tooltipOptions={{ position: 'bottom' }}
                                    icon="pi pi-table" 
                                    className="mt-4"
                                    style={{ height: '45px' }}
                                    onClick={() => {
                                        if (subscriptionTableModalRef.current) {
                                            subscriptionTableModalRef.current.show(contract?.training);
                                        }
                                    }} 
                                />
                                <MeaButton permission={PERMISSION_TRAINING_CONTRACTS.UPDATE} outlined label="Modifier le total" icon="pi pi-pencil" className="mt-4"
                                    style={{ height: '45px' }}
                                    onClick={() => {
                                        if (updateContractTotalAmountModalRef.current) {
                                            updateContractTotalAmountModalRef.current.show(() => {
                                                callback?.();
                                            });
                                        }
                                    }} />
                            </div>
                        </div>
                        <div className="flex align-items-center mr-0 md:mr-5">
                            <div>
                                <span className="font-medium text-600">Total</span>
                                <p className="mt-1 mb-0 text-900 text-2xl font-medium">
                                    <MeaContractTotalAmount contract={contract} big={true} schoolId={schoolId} trainingId={trainingId} />
                                </p>
                            </div>
                        </div>
                        <div className="flex align-items-center mt-3 md:mt-0">

                            <div>
                                <span className="font-medium text-600">Reste à payer</span>
                                <p className="mt-1 mb-0 text-900 text-2xl font-medium">
                                    <MeaContractDueBalance contract={contract} big={true} schoolId={schoolId} trainingId={trainingId} />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default ContractDetailHeader;
